/**
 * Format a date as DD-MM-YYYY.
 *
 * Returns a dash placeholder ('—') for missing or unparseable input rather than
 * 'NaN-NaN-NaN'. Deprecated releases, for example, may have an empty releaseDate.
 *
 * @param {string|number|Date} dateString
 * @param {string} [fallback='—']  value returned for empty/invalid input
 * @returns {string}
 */
export const formatDate = (dateString, fallback = '—') => {
  if (dateString == null || dateString === '') return fallback;

  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return fallback;

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};
